module.exports = __webpack_public_path__ + "img/account-routing-check.8c43d534.png";